import { Store } from 'pullstate';

export const OnboardingStore = new Store({
    userDoc: {
        ready: false,
    },
    step: 1,
});
